import { useAuthenticatedApi, currentDatabaseSelector, selectedStateHighwaysSubnetworkState } from '@transport-insights/uikit';
import { useConfig } from '@src/context/config';
import { useRecoilValue } from 'recoil';
import { selectedRegionRoadTypeState, selectedTemporaryRegionRoadTypeState } from '../state';

export default () => {
  const { PERFORMANCE_API_URL } = useConfig();
  const api = useAuthenticatedApi(PERFORMANCE_API_URL);
  const rca = useRecoilValue(currentDatabaseSelector);
  const selectedSubnetwork = useRecoilValue(selectedStateHighwaysSubnetworkState);
  const selectedRegionRoadType = useRecoilValue(selectedRegionRoadTypeState);
  const selectedTemporaryRegionRoadType = useRecoilValue(selectedTemporaryRegionRoadTypeState);
  const queryParams = [];
  if (rca?.id === 81) {
    queryParams.push(`subnetwork=${selectedSubnetwork}`);
  }
  if (rca?.id >= 1000) {
    queryParams.push(`shlr=${selectedTemporaryRegionRoadType || selectedRegionRoadType}`);
  }
  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

  return {
    async getSafetyKpiData(rcaId, lockYear) {
      const encodedLockYear = lockYear.replace('/', '-');
      const url = `/safety/map-kpi/${rcaId}/${encodedLockYear}${queryString}`;
      const res = await api.get(url);
      return res?.data || [];
    },
    async getAchievementKpiData(rcaId, lockYear) {
      const encodedLockYear = lockYear.replace('/', '-');
      const url = `/achievements/map-kpi/${rcaId}/${encodedLockYear}${queryString}`;
      const res = await api.get(url);
      return res?.data || [];
    },
    async getDeliveryPerformanceKpiData(rcaId) {
      const url = `/activity-class-costs/kpi/${rcaId}${queryString}`;
      const res = await api.get(url);
      return res?.data || [];
    },
    async getActivityManagementKPI(rcaId, lockYear) {
      const encodedLockYear = lockYear.replace('/', '-');
      const url = `/activity-management/map-kpi/${rcaId}/${encodedLockYear}`;
      const res = await api.get(url);
      return res?.data || [];
    },
    async getCoInvestorAssuranceKPI(rcaId, lockYear) {
      const encodedLockYear = lockYear.replace('/', '-');
      const url = `/coinvestor/map-kpi/${rcaId}/${encodedLockYear}`;
      const res = await api.get(url);
      return res?.data || [];
    },
    async getServicePerformanceMapKPI(rcaId, lockYear) {
      const encodedLockYear = lockYear.replace('/', '-');
      const url = `/service-performance/map-kpi/${rcaId}/${encodedLockYear}`;
      const res = await api.get(url);
      return res?.data || [];
    },
    async getDataQualityKPI(rcaId, lockYear) {
      const encodedLockYear = lockYear.replace('/', '-');
      const url = `/data-quality-kpi/${rcaId}/${encodedLockYear}`;
      const res = await api.get(url);
      return res?.data || [];
    },
    async getNetworkCharacteristics(rcaId, lockYear) {
      const encodedLockYear = lockYear.replace('/', '-');
      const url = `/network-characteristics/map-kpi/${rcaId}/${encodedLockYear}`;
      const res = await api.get(url);
      return res?.data || [];
    },
    async getMapData(type, rcaId, lockYear) {
      const encodedLockYear = lockYear.replace('/', '-');
      const url = `/map-data/${type}/${rcaId}/${encodedLockYear}${queryString}`;
      const res = await api.get(url);
      return res?.data || [];
    },
  };
};
